import { render, staticRenderFns } from "./form-epoca-alvo.vue?vue&type=template&id=3a8d49f5&"
import script from "./form-epoca-alvo.vue?vue&type=script&lang=js&"
export * from "./form-epoca-alvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports